import { render } from "./OfferSection.vue?vue&type=template&id=04121464&scoped=true"
import script from "./OfferSection.vue?vue&type=script&lang=js"
export * from "./OfferSection.vue?vue&type=script&lang=js"

import "./OfferSection.vue?vue&type=style&index=0&id=04121464&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04121464"]])

export default __exports__